import React from 'react';
import {cms} from 'helpers/stableValues';

const NativeLayout = () => {
  return (
    <section className="bg-white py-4">
      <div className="container px-4">
        <div className="w-lg-6-10 mx-auto" dangerouslySetInnerHTML={{__html: cms.content.rendered}} />
      </div>
    </section>
  );
};

export default NativeLayout;